import { Button } from '@shared/components/ui/button';
import { faFileArrowDown, faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useExportCRMExcel } from '../../hooks/useExportCRMExcel';

interface Props {
  search?: string;
  teamIds?: string[];
  statusId?: number;
  shopIds?: string[];
  tagId?: number;
  shippingCountryCodes?: string[];
  paymentMethodIds?: string[];
  productIds?: string[];
  dateFrom?: string;
  dateTo?: string;
  sorting?: { field: string; direction: 'asc' | 'desc' };
  visibleColumns?: string[];
}

export const DownloadExcelButton: React.FC<Props> = ({
  search,
  teamIds,
  statusId,
  shopIds,
  tagId,
  shippingCountryCodes,
  paymentMethodIds,
  productIds,
  dateFrom,
  dateTo,
  sorting,
  visibleColumns,
}) => {
  const { exportCRMOrders, isExporting } = useExportCRMExcel();

  const handleExport = () => {
    exportCRMOrders(
      search,
      teamIds?.join(','),
      statusId,
      shopIds,
      tagId,
      shippingCountryCodes?.join(','),
      paymentMethodIds,
      productIds,
      dateFrom,
      dateTo,
      sorting,
      visibleColumns,
    );
  };

  return (
    <Button
      onClick={handleExport}
      disabled={isExporting}
      type="button"
      size="sm"
      variant="outline"
      className="!py-[9px] !px-2 text-foreground/70 hover:text-foreground border-input hover:bg-accent"
      data-testid="export-excel-button"
    >
      {isExporting ? (
        <FontAwesomeIcon icon={faSpinnerThird} className="animate-spin" />
      ) : (
        <FontAwesomeIcon icon={faFileArrowDown} />
      )}
    </Button>
  );
};
